import Enumerable from "linq";
import store from "../../../store";
import { IConfiguration } from "../../../domain/configuration";
import { IClipboardItem } from "../../../domain/system";
import { IContentSource } from "../../../domain/drawing";
import { HttpRepository } from "../..";
import { ClipboardItem } from "../../system";

export class ClipboardRepository extends HttpRepository {
  async getLatestTexts(count: number, latestSequenceNo: number): Promise<IClipboardItem<string>[]> {
    if (!this.isValidNumber(count)) { throw new Error("count is invalid!!! count: " + count); }
    if (!this.isValidNumber(latestSequenceNo)) { throw new Error("latestSequenceNo is invalid!!! latestSequenceNo: " + latestSequenceNo); }
    
    const config = store.getters.configuration as IConfiguration;
    const url = config.behavior.localhost.httpUrlPrefix + "/api/clipboard/text/get";
    const query = {
      params: {
        count,
        latestSequenceNo,
      },
    };
    const result = await this.get(url, query);
    return this.toClipboardTextItems(result.data, latestSequenceNo);
  }

  private toClipboardTextItems(texts: string[], latestSequenceNo: number): IClipboardItem<string>[] {
    if (!texts) { return []; }

    // TODO: 本来はここで採番するものではない
    return Enumerable.from(texts)
      .select((t, i) => new ClipboardItem<string>(latestSequenceNo + i + 1, t))
      .toArray();
  }

  private isValidNumber(value: number): boolean {
    return (value !== null && value !== undefined && !isNaN(value) && isFinite(value));
  }

  async getLatestImages(count: number, latestSequenceNo: number): Promise<IClipboardItem<IContentSource>[]> {
    // TODO: WEBAPI対応後に実装.
    console.warn("TODO: assistant対応後に実装(ClipboardRepository).");
    return [];
  }
}
